import type Track from 'bundles/interactive-transcript/models/Track';

const labelCompare = (a: Track, b: Track) => {
  if (a.label < b.label) return -1;
  if (a.label > b.label) return 1;
  return 0;
};

class TrackList {
  private tracks: Track[];

  /**
   * @param {array} tracks An array of Track objects.
   */
  constructor(tracks: Track[]) {
    this.tracks = [...tracks];
    this.tracks.sort(labelCompare);
  }

  toArray() {
    return this.tracks;
  }

  getFromLanguageCode(languageCode?: string) {
    return this.tracks.find((track) => track.languageCode === languageCode);
  }
}

export default TrackList;
